import { Dispatch } from 'react';

import { ChakraFlex } from '@equip.health/ui';
import { ErrorBoundary } from 'react-error-boundary';

import { AssessmentAction } from '~/lib/constants/patients.constants';
import { CompServTask } from '~/lib/util/task.util';

import IntakeSurveyBannerSection from './rightRail/IntakeSurveyBannerSection';
import MessagesSection from './rightRail/MessagesSection';
import OverviewAssessmentsSection from './rightRail/OverviewAssessmentsSection';
import OverviewTasksSection from './rightRail/OverviewTasksSection';
import { RailSectionErrorFallback } from './rightRail/RailSectionErrorFallback';
import { RailSectionErrorLabel } from './rightRail/rightRail.constants';
import UpcomingAppointmentsSection from './rightRail/UpcomingAppointmentsSection';

interface PatientOverviewRightRailV2Props {
  isTasksError?: boolean;
  isTasksLoading?: boolean;
  openTasks?: CompServTask[];
  patientId: string;
  patientTasksCount?: number;
  universalStatusCode?: string;
  updateAssessmentState: Dispatch<AssessmentAction>;
}

const PatientOverviewRightRailV2 = ({
  isTasksError,
  isTasksLoading,
  openTasks,
  patientId,
  patientTasksCount,
  universalStatusCode,
  updateAssessmentState,
}: PatientOverviewRightRailV2Props) => {
  return (
    <ChakraFlex
      data-testid="patient-overview-right-rail-v2"
      direction="column"
      gap="24px"
    >
      <ErrorBoundary
        fallback={
          <RailSectionErrorFallback
            id="patient-overview-right-rail-v2__intake-banner__error"
            label={RailSectionErrorLabel.IntakeBanner}
          />
        }
      >
        <IntakeSurveyBannerSection
          patientId={patientId}
          updateAssessmentState={updateAssessmentState}
        />
      </ErrorBoundary>
      <ErrorBoundary
        fallback={
          <RailSectionErrorFallback
            id="patient-overview-right-rail-v2__appointments__error"
            label={RailSectionErrorLabel.Appointments}
          />
        }
      >
        <UpcomingAppointmentsSection patientId={patientId} />
      </ErrorBoundary>
      <ErrorBoundary
        fallback={
          <RailSectionErrorFallback
            id="patient-overview-right-rail-v2__assessments__error"
            label={RailSectionErrorLabel.Assessments}
          />
        }
      >
        <OverviewAssessmentsSection patientId={patientId} />
      </ErrorBoundary>
      <ErrorBoundary
        fallback={
          <RailSectionErrorFallback
            id="patient-overview-right-rail-v2__messages__error"
            label={RailSectionErrorLabel.Messages}
          />
        }
      >
        <MessagesSection
          patientId={patientId}
          universalStatusCode={universalStatusCode}
        />
      </ErrorBoundary>
      <ErrorBoundary
        fallback={
          <RailSectionErrorFallback
            id="patient-overview-right-rail-v2__tasks__error"
            label={RailSectionErrorLabel.Tasks}
          />
        }
      >
        <OverviewTasksSection
          isError={isTasksError}
          isLoading={isTasksLoading}
          openTasks={openTasks}
          patientId={patientId}
          totalOpenCount={patientTasksCount}
        />
      </ErrorBoundary>
    </ChakraFlex>
  );
};

export default PatientOverviewRightRailV2;
